<template>
  <div class="explain_page">
    <img src="../assets/desc_icon.png" class="explain_icon"/>
    <div class="explain_wrap">
      <a href="http://app.qcql.cn/pdf/R5G快速指南.pdf" target="_blank" class="explain_wrap_item">
        <img src="../assets/desc1.png"/>
        <div>R5G快速指南</div>
      </a>
      <a href="http://app.qcql.cn/pdf/R9H快速指南.pdf" target="_blank" class="explain_wrap_item">
        <img src="../assets/desc2.png"/>
        <div>R9H快速指南</div>
      </a>
      <a href="http://app.qcql.cn/pdf/R9G快速指南.pdf" target="_blank" class="explain_wrap_item">
        <img src="../assets/desc3.png"/>
        <div>R9G快速指南</div>
      </a>
      <a href="http://app.qcql.cn/pdf/使用说明.pdf" target="_blank" class="explain_wrap_item">
        <img src="../assets/desc4.png"/>
        <div>使用说明</div>
      </a>
    </div>

    <div class="related_links">
      <h3>相关链接：</h3>
      <a href="https://tapi.e5ex.com/product?p=CPPZ" target="_blank">产品配置表</a>
      <a href="https://app.e5ex.com/#/introduce" target="_blank">轮端预警</a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  created() {
  },
  mounted(){
  },
  methods: {
  }
}
</script>
<style scoped>
.related_links{
  margin-bottom: 30px;
  padding: 10px;
}
.related_links h3,
.related_links a{
  margin: 5px 0;
  display: block;
}
.explain_page {
  height: 100%;
  width: 100%;
  position: absolute;
  background: url("../assets/back.jpg");
  background-size: 80%;
  padding: 10px;
}
.explain_icon{
  width: 60%;
  display: block;
  margin: 50px auto;
}
.explain_wrap{
  display: flex;
  flex-wrap: wrap;
}
.explain_wrap_item{
  width: calc(50vw - 30px);
  height: calc(50vw - 30px);
  margin: 10px;
  position: relative;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 10px 2px #CCCCCC;
}
.explain_wrap_item img{
  width: 100%;
  height: 100%;
}
.explain_wrap_item div{
  position: absolute;
  bottom: 10px;
  left: 0px;
  padding: 0 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical; 
  -webkit-line-clamp: 1; 
  overflow: hidden;
  text-align: center;
  width: 100%;
  color: #000;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/explain.vue